import { injectable, inject } from 'inversify';
import type { IPanelFacturacionRepository } from '@/domain/repositories/IPanelFacturacionRepository';
import { PanelFacturacion } from '@/domain/entities/PanelFacturacion';
import { TYPES } from '@/di/tokens';

@injectable()
export class GetBillingPanelAction {
  constructor(
    @inject(TYPES.IPanelFacturacionRepository) private billingRepository: IPanelFacturacionRepository
  ) {}

  async execute(id: number): Promise<PanelFacturacion> {
    return await this.billingRepository.getById(id);
  }
}
